import type {
  GetNextBuyflowStepResponse,
  VerifyWidget,
} from '@/lib/TypesOpenApi';
import type {BaseSyntheticEvent} from 'react';
import {proxy, useSnapshot} from 'valtio';
import {
  type StepWidgetStore,
  StepsPath,
  stepsMap,
} from '../routing/StepsRouting';
import {useWidget} from '../routing/StepsWizardContext';

const widget = stepsMap['VERIFY']!.store;

export interface VerifyPageWidget {
  /** Base widget to relay on */
  widget: StepWidgetStore;
  content?: GetNextBuyflowStepResponse;
  verifyWidget?: VerifyWidget;
  hasPopup: boolean;
}

export const verifyWidget = proxy<VerifyPageWidget>({
  widget,
  get content() {
    return this.widget.content;
  },

  get verifyWidget() {
    const widgets =
      widget.content?.buyflowStep.buyflowWidgets
        ?.map(({verifyWidget: w}) => w!)
        .filter(w => !!w) || [];
    return widgets[0];
  },

  get hasPopup() {
    // In lieu of a better method, see if the popup widget is both present and populated.
    const header = this.verifyWidget?.popUpWidget?.titleHeader;
    return header !== undefined && header !== '';
  },
});

export const useVerifyWidget = () => useWidget(StepsPath.Verify, verifyWidget);

export interface VerifyState {
  firstName?: string;
  lastName?: string;
  phone?: string;
  isMobile?: boolean;
  businessName?: string;
  businessContactFirstName?: string;
  businessContactLastName?: string;
  isDasherDialogOpen: boolean;
  triggerFormSubmit?: (e?: BaseSyntheticEvent) => Promise<void>;
}

// if add any new field, add the new field to the below reset function also
export const store = proxy<VerifyState>({
  firstName: undefined,
  lastName: undefined,
  phone: undefined,
  isMobile: undefined,
  businessName: undefined,
  businessContactFirstName: undefined,
  businessContactLastName: undefined,
  isDasherDialogOpen: false,
  triggerFormSubmit: undefined,
});

export const resetVerifyState = () => {
  store.firstName = undefined;
  store.lastName = undefined;
  store.phone = undefined;
  store.isMobile = undefined;
  store.businessName = undefined;
  store.businessContactFirstName = undefined;
  store.businessContactLastName = undefined;
  store.isDasherDialogOpen = false;
  store.triggerFormSubmit = undefined;
};

export const useVerifyState = () => useSnapshot(store);

export const setState = (
  firstName?: string,
  lastName?: string,
  phone?: string,
  isMobile?: boolean,
  businessContactFirstName?: string,
  businessContactLastName?: string,
  businessName?: string,
) => {
  store.firstName = firstName;
  store.lastName = lastName;
  store.phone = phone;
  store.isMobile = isMobile;
  store.businessContactFirstName = businessContactFirstName;
  store.businessContactLastName = businessContactLastName;
  store.businessName = businessName;
};

export const setDasherDialogState = (
  isOpen: boolean,
  submitFn?: (e?: BaseSyntheticEvent) => Promise<void>,
) => {
  store.isDasherDialogOpen = isOpen;
  store.triggerFormSubmit = submitFn;
};
